import EmptyState from "@/components/EmptyState";
import usePageTitle from "@/hooks/usePageTitle";
import CommissionTabLayout from "../_CommissionTabLayout";
import { useRequireCommissionPlatform } from "../useCommissionPlatformGate";

export default function CommissionIngestPage() {
  usePageTitle("/billing/finance/commission/ingest", "Ingest");
  useRequireCommissionPlatform();

  return (
    <CommissionTabLayout>
      <EmptyState title="Coming soon" caption="Ingest workflows are not available yet." iconName="upload" />
    </CommissionTabLayout>
  );
}
